import { BaseAPI, type Common } from '../common.js';

export default abstract class OrchestratorAPI extends BaseAPI {
  protected BASE_URL = '/orchestrator';

  protected abstract API_PATH: string;

  protected constructPath: InstanceType<typeof Common>['constructPath'] = (path, query) => {
    if (!path.startsWith('/')) {
      path = '/' + path;
    }
    return this.common.constructPath(`${this.BASE_URL}${this.API_PATH}${path}`, query);
  };

  protected deserialize = <T extends { created: string; updated: string }>(
    obj: T,
    options?: { dateFields?: (keyof T)[] }
  ): T => {
    const { dateFields = ['created', 'updated'] } = options ?? {};
    const result = { ...obj } as unknown as Record<keyof T, Date | null>;
    for (const dateField of dateFields) {
      const value = result[dateField];
      if (value != null) {
        result[dateField] = new Date(value);
      }
    }
    return result as unknown as T;
  };
}
